import { observer } from 'mobx-react';
import React, { useRef, useState } from 'react';
import { VaultFilters } from '../../../../../vault/component/VaultFilters/VaultFilters';
import { VaultSearch } from '../../../../../vault/component/VaultSearch/VaultSearch';
import { VaultList } from '../../../../../vault/component/VaultList/VaultList';
import { VaultMetadataPanel } from '../../../../../vault/component/VaultMetadataPanel/VaultMetadataPanel';
import { useStore } from '../../../../../app/data/root.store';
import { MobileAssetVaultTabContent, MobileAssetVaultTabHeader, MobileAssetVaultTabWrapper, MobileAssetVaultTabSearchWrapper } from './MobileAssetVaultTab.styles';
import { VaultSearchButton, VaultUploadButtonText } from '../../../../../vault/component/VaultPage/Vault.styles';
import { ModalCloseIcon, MobileSearchIcon } from '../../../../../../assets/icons/common/common-icons';
import { VaultButtonBlack } from '../../../../../vault/component/VaultHeader/VaultHeader.styles';
import { VaultUploadIcon } from '../../../../../vault/assets/icons';
import { ActionLockedIconWithTooltip } from '../../../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { MAX_VAULT_FILE_SIZE_MB, SUPPORTED_FILE_FORMATS, SUPPORTED_FILE_FORMATS_MAP } from '../../../../../vault/component/Vault.const';
import { AppLoader } from '../../../../../../common/components/Loaders/AppLoader';
import { LimitationModal } from '../../../../../../common/components/LimitationModal/LimitationModal';
import { VaultModals } from '../../../../../vault/component/VaultModals/VaultModals';
import { upload, confirmVaults } from '../../../../../vault/data/vault.service';

export const MobileAssetVaultTab = observer(() => {
  const { uiStore, vaultStore, userStore, billingStore } = useStore();
  const isMetadataPanelOpen = vaultStore.isMetadataPanelOpen;
  const [showMobileSearchBox, setShowMobileSearchBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef();

  const handleFileChange = async (e) => {
    setIsLoading(true);
    try {
      const files = e.target.files;
      if (files && files.length > 0) {
        const supportedFormats = Object.values(SUPPORTED_FILE_FORMATS_MAP);
        const maxSize = (MAX_VAULT_FILE_SIZE_MB * 1024 * 1024);
        const mappedFiles = Array.from(files).reduce((acc, file) => {
          if (supportedFormats.includes(file.type) && (file.size <= maxSize)) {
            acc.accepted.push(file);
          } else {
            acc.rejected.push(file);
          }
          return acc;
        }, { accepted: [], rejected: [] });
        
        const hasAcceptedFiles = (mappedFiles.accepted && mappedFiles.accepted.length > 0);
        if (!hasAcceptedFiles) {
          vaultStore.setFilesData({ errors: mappedFiles.rejected[0].errors });
          vaultStore.setVaultFormStep('fail');
          return;
        }

        const formData = new FormData();
        mappedFiles.accepted.forEach(file => {
          formData.append('files', file);
        });

        const response = await upload(formData, true);
        if (201 === response.statusCode) {
          const vaults = response.data;
          await confirmVaults(vaults.map(vault => vault.id), false, true, [vaultStore.assetId]);
          await vaultStore.refetchFiles();
          vaultStore.setFilesData({ numOfItems: mappedFiles.accepted.length, singleFileName: mappedFiles.accepted[0].name });
          vaultStore.setVaultFormStep('deep-analysis');
        }
      }
    } catch (error) {
      console.error('Error uploading documents:', error);
    } finally {
      setIsLoading(false);
    }

    e.target.value = '';
  };

  const handleUploadClick = () => {
    if (userStore.isActionBlockedByRole('addVaultFile')) {
      userStore.setShowLimitedSharedAccess(true);
      return;
    }

    if (userStore.isDemoMode) {
      billingStore.setShowPricingTableModal(true);
    } else if (userStore.isReadOnlyMode) {
      uiStore.setShowDemoLimitationModal(true);
    } else {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      {isLoading && <AppLoader backdrop absolute />}
      <MobileAssetVaultTabWrapper>
        <MobileAssetVaultTabHeader>
          <MobileAssetVaultTabSearchWrapper>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {!showMobileSearchBox ? (
                <>
                  <VaultButtonBlack 
                    style={{ fontSize: '14px', height: '36px', padding: '0 12px', marginLeft: 'auto' }}
                    onClick={handleUploadClick}
                  >
                    <VaultUploadIcon />
                    <VaultUploadButtonText>
                      Upload files
                      {userStore.isActionBlockedByRole('addVaultFile') && <ActionLockedIconWithTooltip iconColor={'#FFF'} isRoleBlocked={true} marginLeft={'0px'} />}
                    </VaultUploadButtonText>
                  </VaultButtonBlack>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept={SUPPORTED_FILE_FORMATS.join(',')}
                    multiple
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <VaultSearchButton onClick={() => setShowMobileSearchBox(true)}>
                    <MobileSearchIcon />
                  </VaultSearchButton>
                </>
              ) : (
                <>
                  <div style={{ flex: 1, marginRight: '8px' }}>
                    <VaultSearch isMobile hideTitleOnMobile />
                  </div>
                  <VaultSearchButton onClick={() => setShowMobileSearchBox(false)}>
                    <ModalCloseIcon />
                  </VaultSearchButton>
                </>
              )}
            </div>

          </MobileAssetVaultTabSearchWrapper>
          <VaultFilters />
        </MobileAssetVaultTabHeader>
        <MobileAssetVaultTabContent>
          <VaultList />
        </MobileAssetVaultTabContent>
      </MobileAssetVaultTabWrapper>

      {!uiStore.isVaultMetadataPanelModalThreshold && isMetadataPanelOpen && <VaultMetadataPanel />}
      {uiStore.isShowDemoLimitationModal && <LimitationModal modalType={'readOnlyPortfolio'} onStartMyPortfolio={() => { billingStore.setShowPricingTableModal(true) }} onClose={() => { uiStore.setShowDemoLimitationModal(false) }} />}
      <VaultModals />
    </>
  );
}); 